'use client'
import type { LinkField, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { getLinkFieldURL } from '@/services/storyblok/Storyblok.helpers'
import { Text } from 'ui/src/components/Text/Text'
import { ArrowDownIcon } from 'ui/src/icons/ArrowIcon'
import { xStack } from 'ui/src/patterns/stack'
import { arrowIcon, card } from './CardLinkBlock.css'

type CardVariant = 'primary' | 'secondary'

export type CardLinkBlockProps = SbBaseBlockProps<{
  heading: string
  description: string
  link: LinkField
  variant?: CardVariant
}>

export function CardLinkBlock({ blok }: CardLinkBlockProps) {
  return (
    <a className={card[blok.variant ?? 'secondary']} href={getLinkFieldURL(blok.link)}>
      <header className={xStack({ alignItems: 'center', justifyContent: 'space-between', gap: 'sm' })}>
        <Text as="span" size={{ _: 'xl', lg: 'xxl' }}>
          {blok.heading}
        </Text>
        <ArrowDownIcon className={arrowIcon} direction="right" aria-hidden="true" />
      </header>
      <Text as="p" size={{ _: 'xs', lg: 'md' }}>
        {blok.description}
      </Text>
    </a>
  )
}
